// NOTE: this file was auto-generated with `libraries/icons/src/_private/transform.ts`
// Any manual edits will be overwritten via `rush build`

import { SVGProps } from 'react';

const BrowserLogo = (props: SVGProps<SVGSVGElement>) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 192 192"
		xmlns="http://www.w3.org/2000/svg"
		fill="none"
		{...props}
	>
		<circle cx={96} cy={96} r={74} stroke="#000" strokeWidth={12} />
		<ellipse cx={96} cy={96} stroke="#000" strokeWidth={12} rx={30} ry={74} />
		<path
			stroke="#000"
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeWidth={12}
			d="M28 72h136M28 120h136"
		/>
	</svg>
);
export default BrowserLogo;
